import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { CALCULATOR_TOOLS } from "../data/calculatorCatalog";
import "./CommandBar.css";

const CommandBar = ({ open, setOpen }) => {
  const [query, setQuery] = useState("");
  const history = useHistory();

  if (!open) return null;

  const normalizedQuery = query.trim().toLowerCase();
  const filtered = CALCULATOR_TOOLS.filter((tool) =>
    [tool.name, tool.description, ...(tool.categories || [])]
      .join(" ")
      .toLowerCase()
      .includes(normalizedQuery)
  );

  const handleSelect = (toolId) => {
    history.push(`/calculator/${toolId}`);
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="command-overlay" onClick={() => setOpen(false)}>
      <div className="command-bar" onClick={(event) => event.stopPropagation()}>
        <input
          autoFocus
          placeholder="Search tools..."
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />

        <div className="command-results">
          {filtered.map((tool) => (
            <div
              key={tool.id}
              className="command-item"
              onClick={() => handleSelect(tool.id)}
            >
              <span>{tool.name}</span>
              <small>{tool.badge}</small>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommandBar;
